import React from 'react';
import { Link } from 'react-router-dom';
import './HeroHome.css';

const HeroHome = () => {
  return (
    <section className="home-section">
      <div className="hero-home">
        <h1>Unlock Deals. Earn <span>Gold.</span><br/> Shop Smarter with Discount Dost.</h1>
        <p className='para'>
          India’s friendliest savings app — discover amazing deals at your favorite stores and earn real gold on every spend.
        </p>
        <div className='btnHolder'>
        <div className="hero-buttons">
          <a href="#how-it-works" className="secondary-btn">👉 See How It Works</a>
          <Link to="/partner" className="primary-btn">🤝 Partner With Us</Link>
        </div>
        </div>
      </div>
    </section>
  );
};

export default HeroHome;